import { useQuery } from '@tanstack/react-query';

import { IMyResult } from '../models';
import { getMyResult, topicTestsConst } from '..';

export const useMyResult = (ticketId?: number) => {
  const { data: myResults, ...args } = useQuery<IMyResult>({
    queryKey: [topicTestsConst.queryKeys.USE_MY_RESULT, ticketId],
    queryFn: getMyResult(ticketId),
    enabled: !!ticketId
  });

  return { myResults, ...args };
};
